const CATEGORY_REDIRECTS = {
  'car-4wd-minibus-rental': 'car-rental',
  'agricultural-farm-machinery': 'farm-machinery',
  'after-hours-home-doctors': 'after-hours-doctors',
  'shed-builders': 'sheds',
  'towbars-towing-equipment': 'towbars',
  'abrasive-sand-blasting': 'abrasive-sandblasting',
  '4x4-equipment-accessories': '4x4-accessories',
  'building-maintenance-services': 'property-maintenance',
  'used-cars': 'used-car-dealers',
  'new-cars': 'car-dealers',
  'laser-equipment-cutting-engraving': 'laser-cutting-engraving',
  'tourist-attractions-services': 'things-to-do',
  hypnotherapists: 'hypnotherapy',
  'swimming-centres': 'aquatic-centres',
  signs: 'sign-shops',
  'tax-consultants': 'tax-accountants',
  'shock-absorbers-springs-suspension': 'shock-absorbers-suspension',
  'roof-construction': 'roofing-contractors',
  roofers: 'roofing-contractors',
  'pool-builders-repairs': 'swimming-pool-builders',
  'motorcycle-sales-accessories': 'motorcycle-dealers',
  'lawn-mowing': 'lawn-mowing-services',
  'excavating-earthmovers': 'excavator-earthmoving-hire',
  decking: 'deck-builders',
  demolition: 'demolition-contractors',
  'laminate-vinyl-flooring': 'flooring-stores',
  'flooring-laminate-vinyl': 'flooring-stores',
  'caravans-camper-trailers-repairs': 'caravan-repairs',
  'caravans-camper-trailers-sales-accessories': 'caravans-sales-parts',
  'bikes-bicycle-accessories': 'bike-shops',
  towing: 'towing-services',
  'computer-repairs-installation': 'computer-repairs',
  'motor-mechanics': 'mechanics',
  'dog-cat-clipping-washing-grooming': 'dog-cat-grooming',
  fencing: 'fencing-contractors',
  windows: 'aluminium-windows',
  'cargo-freight-shipping-containers': 'container-sales-hire',
  'security-systems-consultants': 'security-systems',
  'skin-clinics': 'cosmetic-skin-clinics',
  'marine-sails': 'sailmakers',
  'web-design-hosting-services': 'website-design-services',
  'marketing-agencies-consultants': 'digital-marketing-agencies',
  'skin-treatment-products': 'cosmetic-skin-clinics',
  heaters: 'heating',
  'heating-sales-repairs': 'heating',
  'air-conditioning-supplies-equipment': 'ducted-air-conditioning',
  'boring-drilling': 'bore-drilling',
  'cosmetic-surgeons': 'plastic-surgeons',
  'carpet-dyeing-vinyl-repairs': 'carpet-vinyl-repairs',
  'flooring-timber-bamboo': 'timber-bamboo-flooring',
  'mobile-phones-repairs': 'phone-tablet-repairs',
  gasfitters: 'gas-fitters',
  'steel-fabricators-manufacturers': 'steel-fabrications',
  'tank-sales-installation': 'water-tanks',
  'tip-truck-hire': 'tipper-hire',
  'trailer-sales-repairs': 'trailers',
  'lawnmower-sales-repairs': 'lawn-mowers',
  'commercial-industrial-refrigeration': 'refrigeration',
  'tv-antenna-sales-installation': 'tv-antenna-installations',
  'hydraulic-equipment-sales-repairs': 'hydraulics',
  'curtain-sales-repairs': 'curtains',
  'air-conditioning-commercial-industrial': 'commercial-air-conditioning',
  'wardrobes-sales-installation': 'wardrobes',
  'door-sales-fittings-repairs': 'doors',
  'garage-doors-sales-repairs': 'garage-doors',
  storage: 'self-storage',
  'storage-general': 'self-storage',
  'security-doors-windows': 'security-screens',
  'lawnmowing-maintenance': 'lawn-mowing',
  'air-conditioning-home': 'air-conditioning',
  'builders-residential-commercial': 'builders',
  'shutters-louvres': 'shutters',
  funerals: 'funeral-directors',
  'personal-injury-law': 'personal-injury-lawyers',
  'family-law': 'family-lawyers',
  'seafood-wholesaler-co-op': 'seafood-retailer-wholesalers',
  'roof-restorations': 'roof-restorations-repairs',
  'home-cleaners': 'cleaners',
  'solar-energy': 'solar-power-systems',
  'commercial-industrial-cleaners': 'commercial-cleaners',
  patios: 'patio-builders',
  'auto-air-conditioning': 'car-air-conditioning',
  'building-inspections': 'building-pest-inspections',
  'take-away-food': 'takeaway-food',
  'real-estate-agencies': 'real-estate-agents',
  'security-screens': 'security-doors-screens',
  'bars-nightclubs': 'bars',
  'insect-screens': 'fly-screens',
  bottleshops: 'bottle-shops',
  'digital-dvd-video-production': 'video-production-services',
  'bathroom-renovators': 'bathroom-renovations',
  'work-wear': 'workwear',
  'concrete-cutting-drilling-grinding-sawing': 'concrete-cutting',
  'baby-childrens-clothing': 'baby-children-s-clothing',
  directories: 'digital-marketing-agencies',
  'disability-scooters': 'mobility-scooters',
  'child-care-centres-preschools': 'child-care-centres',
  'carpet-retailers': 'carpet-stores',
  'furniture-delivery': 'home-delivery',
  'adult-entertainment-escorts': 'adult-entertainment-strippers',
  'sliding-doors-equipment': 'sliding-doors',
  bootcamps: 'boot-camps',
  'home-automation': 'smart-home',
  'fast-food-delivery': 'food-delivery',
  'bariatric-surgeon': 'bariatric-surgeons',
  'mobile-djs': 'djs',
  'clock-sales-repairs': 'clocks',
  'preformance-trainnig': 'performance-training',
  'toilet-washroom-services': 'toilet-hygiene-services',
  'windscreen-repairs': 'windscreen-repairs-replacements',
  preschools: 'preschools-kindergartens',
  'ladies-fashion': 'women-s-clothing',
  threading: 'eyebrow-threading',
  'correspondence-online-schools': 'online-learning',
  'generator-sales-hire-repairs': 'generators',
  'cafes-coffee-shops': 'cafes',
  'oven-installation': 'oven-installations-repairs',
  'google-facebook-ads-agencies': 'web-profile-design',
  'social-media-agencies': 'web-profile-design',
  'colourbond-fencing': 'colorbond-fencing',
  beekeepers: 'beekeepers-beekeeping-supplies',
  'glass-glaziers-repairs-replacements': 'glass-repairs-replacements',
  'training-staff-development': 'training-centres',
  'surf-wear-equipment-accessories': 'surf-shops',
  'pipes-fittings': 'pipes-pipe-fittings',
  '24-7-emergency-electricians': 'emergency-electricians',
  'fire-protection-consultants-equipment': 'fire-protection-services',
  'iv-hydration': 'iv-therapy',
  'kitchen-renovations-design': 'kitchen-renovations-installations',
  'kitchen-renovations-designers': 'kitchen-renovations-installations',
  'english-tutor': 'english-tutors',
  'chemistry-tutor': 'chemistry-tutors',
  'shared-workspace': 'shared-workspaces',
  veneers: 'dental-veneers',
  'building-alterations-renovations': 'building-home-renovations',
  'car-wash': 'car-wash-detailing',
  'car-wash-cleaning-detailing': 'car-wash-detailing',
  'fridge-repairs-seals': 'fridge-repairs',
  'phone-tablet-repairs': 'mobile-phone-repairs',
  'employment-services': 'employment-agencies-services',
  'mining-industrial-vehicles': 'mining-industrial-vehicle-rentals',
  confectionery: 'lolly-shops',
  'piano-lessons': 'piano-teachers',
  'hire-equipment': 'equipment-hire',
  'rubbish-waste-removal': 'rubbish-removal',
  'waste-reduction-disposal': 'waste-reduction-removal',
  'flooring-anti-slip-epoxy': 'epoxy-flooring',
  'playground-auditors-equipment': 'playground-equipment',
  'gates-sales-installation-repairs': 'gate-installation-repairs',
  'house-removals': 'house-relocation',
  'asbestos-removalists': 'asbestos-removals',
  waxing: 'waxing-salons',
  'daikin-air-conditioning': 'daikin-air-conditioners',
  'fujitsu-air-conditioning': 'fujitsu-air-conditioners',
  'panasonic-air-conditioning': 'panasonic-air-conditioners',
  'cash-registers-pos-systems': 'electronic-pos-systems',
  'first-aid-instruction-supplies': 'first-aid-courses-supplies',
  'horse-care': 'horse-care-supplies',
  'nurseries-supplies': 'nursery-supplies',
  'phone-messages-on-hold': 'voicemail-message-services',
  'break-clutch-services': 'brake-clutch-services',
  'sporting-goods': 'sports-stores',
  'rock-climbing-venues-equipment': 'indoor-rock-climbing-venues',
  'limousines-chauffeured-cars': 'limousines',
  'general-valuers': 'general-valuers-appraisers',
  'eye-surgeons': 'eye-surgeons-clinics',
  'golf-coaches': 'golf-lessons',
  'exercise-physiologist': 'sports-exercise-physiologists',
  'cloud-services': 'cloud-computing',
  'bamboo-timber-flooring': 'timber-flooring',
  'pontoons-jetties': 'wharf-pontoon-jetty-construction',
  'retirement-communities-homes': 'retirement-villages-communities-homes',
  'investigation-services': 'private-investigators-detectives',
  hydortherapy: 'hydrotherapy',
  'motor-homes-rvs-campervans-sales-hire': 'motor-homes-rvs-campervans-sales',
  'dog-cat-grooming': 'dog-grooming',
};

module.exports = CATEGORY_REDIRECTS;
